"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _react = _interopRequireWildcard(require("react"));
var _BrandLogo = require("../BrandLogo");
var _Grid = require("../Grid");
var _MenuContext = require("./MenuContext");
var _MenuItem = require("./MenuItem");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _menuModule = _interopRequireDefault(require("@albelli/arc-3/lib/menu.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const HeaderTemplate = _ref => {
  let {
    topBar,
    menu,
    mainUrl,
    localizedMenuName,
    vendor,
    ...props
  } = _ref;
  //The two menus require check boxes and special handling for in mobile view..
  const mainMenuId = _menuModule.default["main-menu"];
  const accountMenuId = _menuModule.default["account-menu"]; //Must be set in menu.json
  const vendorName = vendor === null || vendor === void 0 ? void 0 : vendor.split(".")[0].toLowerCase();

  //un-check the check boxes on screen rotate/resize
  const mainMenuCheckBox = (0, _react.useRef)(null);
  const accountMenuCheckBox = (0, _react.useRef)(null);
  const handleResize = (0, _lodash.default)(() => {
    mainMenuCheckBox.current.checked = false;
    accountMenuCheckBox.current.checked = false;
  }, 133);
  (0, _react.useEffect)(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);
  const MenuBar = _ref2 => {
    let {
      topBar,
      vendor,
      ...props
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
      type: "checkbox",
      ref: mainMenuCheckBox,
      className: "arc3-hide-for-medium-up ".concat(_menuModule.default["arc3-menu-toggle"], " ").concat(mainMenuId),
      "data-cy": "HeaderMainMenuCheckbox"
    }), /*#__PURE__*/_react.default.createElement("input", {
      type: "checkbox",
      ref: accountMenuCheckBox,
      className: "arc3-hide-for-medium-up ".concat(_menuModule.default["arc3-menu-toggle"], " ").concat(accountMenuId)
    }), /*#__PURE__*/_react.default.createElement("div", _extends({
      className: _menuModule.default["arc3-menu__bar"]
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(_menuModule.default["arc3-container"], " arc3-container")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(_menuModule.default["arc3-menu__bar__mobile-btn"], " arc3-hide-for-medium-up")
    }, localizedMenuName), /*#__PURE__*/_react.default.createElement("div", {
      className: "arc3-hide-for-medium-up",
      href: "{#}"
    }, /*#__PURE__*/_react.default.createElement(_BrandLogo.BrandLogo, {
      className: _menuModule.default["arc3-menu__bar__logo"],
      vendor: vendor,
      href: mainUrl,
      white: true,
      small: true,
      "data-cy": "MainBrandLogo"
    })), (topBar === null || topBar === void 0 ? void 0 : topBar.length) > 0 && /*#__PURE__*/_react.default.createElement("ul", {
      className: "".concat(_menuModule.default["arc3-menu__bar__nav"], " arc3-typo-ul-no-style")
    }, topBar.map((i, j) => /*#__PURE__*/_react.default.createElement(_MenuItem.MenuItem, _extends({
      key: i.text
    }, i)))))));
  };
  const SubMenu = _ref3 => {
    let {
      menu,
      vendor,
      ...props
    } = _ref3;
    //only one menu item expanded at a time per subMenu
    const [expanded, setExpanded] = (0, _react.useState)({
      name: "",
      time: ""
    });
    const handleResize = (0, _lodash.default)(() => {
      setExpanded(false);
    }, 133);
    (0, _react.useEffect)(() => {
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, [handleResize]);
    return /*#__PURE__*/_react.default.createElement("div", _extends({
      className: "".concat(_menuModule.default["arc3-container"], " arc3-container")
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: _menuModule.default["arc3-menu__main"]
    }, /*#__PURE__*/_react.default.createElement(_Grid.Grid, {
      cell: true,
      column: 3,
      columnDesktop: 2,
      columnTablet: 3,
      hideSmall: true,
      className: "".concat(_menuModule.default["arc3-menu__main__logo"], " ").concat(_menuModule.default["arc3-menu__main__logo-".concat(vendorName)])
    }, /*#__PURE__*/_react.default.createElement(_BrandLogo.BrandLogo, {
      vendor: vendor,
      href: mainUrl,
      "data-cy": "MainBrandLogo"
    })), /*#__PURE__*/_react.default.createElement(_Grid.Grid, {
      cell: true,
      column: 12,
      columnDesktop: 10,
      className: "".concat(_menuModule.default["arc3-menu__main__nav-container"])
    }, (menu === null || menu === void 0 ? void 0 : menu.length) > 0 && /*#__PURE__*/_react.default.createElement("ul", {
      className: "".concat(_menuModule.default["arc3-menu__main__nav"], " arc3-typo-ul-no-style"),
      id: mainMenuId,
      "data-cy": "HeaderSubMenuContents"
    }, menu === null || menu === void 0 ? void 0 : menu.map((i, j) => /*#__PURE__*/_react.default.createElement(_MenuItem.MenuItem, _extends({
      key: j,
      secondary: true,
      showArrow: true,
      expanded: expanded,
      setExpanded: setExpanded
    }, i)))))));
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    "data-cy": "Menu"
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: _menuModule.default["arc3-menu"]
  }, /*#__PURE__*/_react.default.createElement(MenuBar, {
    topBar: topBar,
    vendor: vendor,
    "data-cy": "MenuBar"
  }), /*#__PURE__*/_react.default.createElement(SubMenu, {
    menu: menu,
    vendor: vendor,
    "data-cy": "SubMenu"
  })));
};
const Header = _ref4 => {
  let {
    topBar,
    mainUrl,
    menu,
    isAuthenticated,
    onLogout,
    onLocalNavigation,
    localizedMenuName,
    vendor
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(_MenuContext.MenuContext.Provider, {
    value: {
      isAuthenticated,
      onLogout,
      onLocalNavigation
    }
  }, /*#__PURE__*/_react.default.createElement(HeaderTemplate, {
    topBar: topBar,
    mainUrl: mainUrl,
    menu: menu,
    localizedMenuName: localizedMenuName,
    vendor: vendor
  }));
};
exports.Header = Header;
Header.propTypes = {
  /** Top bar config object from Public Storefront configuration */
  topBar: _propTypes.default.array,
  /** Main Storefront website URL */
  mainUrl: _propTypes.default.string,
  /** Main menu config object from Public Storefront configuration */
  menu: _propTypes.default.array,
  /** Boolean flag. True if a user is authenticated. Will show logout button */
  isAuthenticated: _propTypes.default.bool,
  /** Logout handler */
  onLogout: _propTypes.default.func,
  /** Local navigation handler (within SPA application) */
  onLocalNavigation: _propTypes.default.func,
  /** Localized menu title */
  localizedMenuName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  /** Current vendor. i.e. 'bonusprint.co.uk' */
  vendor: _propTypes.default.string
};